/**
 * Intro.js default options for a tooltip
 */
export const options = {
  hidePrev: true,
  hideNext: true,
  nextLabel: 'Go to next step',
  doneLabel: 'Got it, thanks!',
  skipLabel: '×',
  showButtons: true,
  showBullets: false,
  showProgress: false,
  showStepNumbers: false,
  exitOnOverlayClick: false,
  exitOnEsc: false,
  keyboardNavigation: false,
};
